export class OS {
  static ios = 'ios'
  static android = 'android'
}

export class App {
  static weixin = 'weixin'
  static weibo = 'weibo'
  static qq = 'qq'
  static normal = 'normal'
}

export class PullTask {
  static pullTencent = 'pullTencent'
  static noop = 'noop'
  static pullSchema = 'pullSchema'
  static appStore = 'appStore'
  static downloadAPK = 'downloadAPK'
}
